<ng-container>
    <!-- <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
        <defs>
            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="parallax">
            <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(213, 91, 74, 0.7)" />
            <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(213, 91, 74, 0.5)" />
            <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(213, 91, 74, 0.3)" />
            <use xlink:href="#gentle-wave" x="48" y="7" fill="#DE5F4D" />
        </g>
    </svg> -->
    <footer class="page-footer flex flex-col text-white justify-center items-center pt-3 pb-1" [ngClass]="isClient ? 'blue' : 'red'">
        <div class="flex flex-row justify-center items-center">
            <div class="px-5 flex flex-col justify-center items-end">
                <div class="flex flex-row items-center my-2">
                    <span class="icon-adress mat-icon"></span>
                    <p>{{ environment.contact.address.street }}<br>{{ environment.contact.address.postalCode }} {{ environment.contact.address.city}} - {{ environment.contact.address.country}}</p>
                </div>
            </div>
            <div class="px-5 border-l-2">
                <div class="flex flex-row justify-start items-center my-2">
                    <span class="icon-mail mat-icon"></span>
                    <a [href]="'mailto:' + environment.contact.email"><p>{{ environment.contact.email }}</p></a>
                    
                </div>
                <div class="flex flex-row justify-start items-center my-2">
                    <span class="icon-phone mat-icon"></span>
                    <p>Tél : {{ environment.contact.tel }}</p>
                </div>
            </div>
        </div>
        <div class="footer-copyright mt-2"><span>©{{ nowYear }} Liveco - v{{ tagVersion }}</span></div>
    </footer>
</ng-container>